// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu5 = () => {
    const { menuDashboard5 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard5?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard5.id,
        title: <FormattedMessage id={`${menuDashboard5.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard5.icon],
        type: menuDashboard5.type,
        children: ChildrenList
    };

    return dashboardList;
};
